export default "/assets/images/awards-celebration.27388cd950f2245c.webm";